export default function Icon2() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.92773 6.875C5.92773 5.83947 6.7672 5 7.80273 5H16.5527C17.5883 5 18.4277 5.83947 18.4277 6.875V16.5625H19.6777C20.8859 16.5625 21.8652 17.5419 21.8652 18.75V21.25C21.8652 22.1129 22.5648 22.8125 23.4277 22.8125C24.2907 22.8125 24.9902 22.1129 24.9902 21.25V15H23.4277V10H24.9902V6.25H26.8652V10H28.4277V15H26.8652V21.25C26.8652 23.1485 25.3262 24.6875 23.4277 24.6875C21.5293 24.6875 19.9902 23.1485 19.9902 21.25V18.75C19.9902 18.5774 19.8503 18.4375 19.6777 18.4375H18.4277V23.75H19.6777V26.25H4.67773V23.75H5.92773V6.875ZM9.05273 15H11.1361L10.3027 20H10.6873L15.3027 15H13.2194L14.0527 10H13.6681L9.05273 15Z"
                fill="white"
            />
        </svg>
    );
}
